<template>
  <div class="skip-button-wrap">
    <BaseButton class="skip-button" tabindex="0" v-bind="$attrs">
      <slot />
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "@/components-ng/BaseButton.vue";

export default {
  components: { BaseButton },
};
</script>

<style lang="scss">
@use "@/colors" as c;

.skip-button-wrap {
  position: fixed;
  top: 20px;
  left: 20px;
  opacity: 0;
  z-index: -1;

  &:focus-within {
    z-index: 999;
    opacity: 1;
  }
}

.skip-button {
  font-size: 1.2rem;
  padding: 0.5rem 1rem !important;

  &:focus-visible {
    box-shadow:
      inset 0 0 0 1px c.$blue-light,
      0 0 0 1px c.$blue,
      0 0 0 5px c.$blue-light;
  }
}
</style>
